export const BLOG_TEMPLATES = [
  {
    id: "listicle",
    label: "Listicle Flow",
    description: "Numbered, high-clarity reading flow for practical advice and step-by-step guides.",
  },
  {
    id: "editorial",
    label: "Editorial Story",
    description: "Magazine-style longform layout with elegant pacing and alternating visual sections.",
  },
  {
    id: "spotlight",
    label: "Spotlight Feature",
    description: "Immersive feature layout with stronger visual rhythm and highlighted section storytelling.",
  },
  {
    id: "framework",
    label: "Framework Cards",
    description: "Structured insight grid for methods, models, and highly actionable content.",
  },
];

export function getTemplateMeta(templateId) {
  return (
    BLOG_TEMPLATES.find((template) => template.id === templateId) ||
    BLOG_TEMPLATES[0]
  );
}
